export default {
  init() {
    // JavaScript to be fired on the home page
    // var isMobile = window.matchMedia("only screen and (max-width: 999px)");
    // var $window = $(window);
    // var bodyHeight = document.body.scrollHeight;
    // var windowHeight = $window.innerHeight();
    // var $heroImage = $(".hero-carousel .hero__background__inner");
    // var $heroContent = $(".hero-carousel .hero__content");
    // if (!isMobile.matches) {
    //   var updatePage = function() {
    //     window.requestAnimationFrame(function() {
    //       var scrollTop = $window.scrollTop();
    //       if (scrollTop && scrollTop > 0) {
    //         if (
    //           scrollTop < bodyHeight - windowHeight &&
    //           scrollTop < window.innerHeight
    //         ) {
    //           var imgScale = 1.1 - scrollTop / 6000;
    //           var contentScale = 1 - scrollTop / 4000;
    //           var imgMove = scrollTop / 10;
    //           //console.log(scrollTop/10000);
    //           contentScale = contentScale < 0 ? 0 : contentScale;
    //           imgScale = imgScale < 1 ? 1 : imgScale;
    //           //imgMove = 0;
    //           $heroContent.css({
    //             transform:
    //               "translate3d(" +
    //               imgMove +
    //               "px," +
    //               imgMove +
    //               "px,0px) scale(" +
    //               contentScale +
    //               ")"
    //           });
    //           $heroImage.css({
    //             transform: "scale(" + imgScale + ")"
    //           });
    //         }
    //       } else {
    //         $heroContent.css({
    //           transform: "translate3d(0,0,0) scale(1)"
    //         });
    //       }
    //     });
    //   };
    //   setInterval(updatePage, 1000 / 60);
    // }
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  }
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js